
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 612 612"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M60.02 210.63h491.15v212.99H60.02z"}}),_c('path',{attrs:{"d":"M543.86 267.65l-49.02 23.55c-4.73-18.28-14.98-29.08-32.71-29.08-24.1 0-36.31 19.95-36.31 52.61 0 32.43 12.21 51.83 36.31 51.83 16.64 0 26.34-8.87 31.59-23.55l51.27 18.27c-13.29 30.22-40.18 51-83.13 51-59.57 0-93.65-39.91-93.65-97.55 0-57.88 36.02-97.51 94.77-97.51 44.88.01 71.46 25.77 80.88 50.43M340.77 408.96h-56.52V220.53h56.52v188.43zm-90.85-77.03c0 26.32-2.79 39.06-10.27 51.83-12.46 20.77-45.72 28.8-74.79 28.8-29.11 0-62.35-8.03-74.82-28.8-7.49-12.77-10.27-25.51-10.27-51.83v-111.4h56.54v112.5c0 12.75 1.67 21.08 6.38 26.62 4.43 5.26 11.63 7.75 22.18 7.75 10.51 0 17.72-2.49 22.16-7.75 4.7-5.54 6.36-13.86 6.36-26.62v-112.5h56.55v111.4zM594.89 306c0-159.53-129.34-288.87-288.89-288.87C146.45 17.13 17.1 146.46 17.1 306c0 159.55 129.34 288.87 288.9 288.87 159.55 0 288.89-129.31 288.89-288.87","fill":"#db0032"}})])
          )
        }
      }
    